import ReactDOM from 'react-dom';

import { savePDF } from '@progress/kendo-react-pdf';

export const exportToPdf = (ref) => {
    savePDF(ReactDOM.findDOMNode(ref), { paperSize: 'A4', fileName: 'spellbook.pdf', forcePageBreak: '.export-card-page-break', margin: '0.01cm', scale: 0.75});
}